module.exports = __webpack_public_path__ + "media/images/metronic/social/dropbox-ddef56e4011fd6b53a9e90103d2478b5.png";